import { useState } from "react";
import API from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { LinkSimple, Copy, EnvelopeSimple } from "@phosphor-icons/react";

/* "Client Approval Link" — same as requests: generate a public approve/decline link for the selected quote, optionally email it */
export default function ClientApprovalLinkButton({ basePath, hasSelected, clientEmail, testPrefix = "job", onGenerated }) {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);
  const [emailed, setEmailed] = useState(false);

  const generate = async (sendEmail) => {
    setBusy(true);
    try {
      const { data } = await API.post(`${basePath}/client-approval-link`, { send_email: sendEmail });
      setLink(data.link); setEmailed(!!data.emailed); setOpen(true);
      toast.success(data.emailed ? "Approval link emailed to the client" : "Client approval link generated");
      onGenerated?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to generate link"); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button size="sm" variant="outline" disabled={!hasSelected || busy} onClick={() => generate(false)}
        title={hasSelected ? "Public link the client can use to approve or decline the selected quote" : "Select a quote first"} data-testid={`${testPrefix}-client-approval-link-btn`}>
        <LinkSimple size={14} className="mr-1" /> {busy ? "Generating…" : "Client Approval Link"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-lg" data-testid={`${testPrefix}-approval-link-dialog`}>
          <DialogHeader>
            <DialogTitle className="font-[Chivo]">Client Approval Link</DialogTitle>
            <DialogDescription>Share this link with the client — they can approve or decline the selected quote without logging in. Approving marks the quote Approved here.</DialogDescription>
          </DialogHeader>
          <div className="flex gap-2">
            <Input value={link} readOnly className="font-mono text-xs" data-testid="approval-link-value" />
            <Button variant="outline" size="sm" onClick={() => { navigator.clipboard.writeText(link); toast.success("Link copied!"); }} data-testid="copy-approval-link-btn"><Copy size={14} /></Button>
          </div>
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <p className="text-[11px] text-muted-foreground">{emailed ? "Emailed to the client." : clientEmail ? `Client email on file: ${clientEmail}` : "No client email on this job — copy the link and send it yourself."}</p>
            {clientEmail && !emailed && (
              <Button size="sm" variant="secondary" disabled={busy} onClick={() => generate(true)} data-testid="email-approval-link-btn"><EnvelopeSimple size={14} className="mr-1" /> Email to client</Button>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
